import { Modal } from "react-bootstrap";
import Popup from "../../../../Helpers/Popup/Popup";
import PopupTitle from "../../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../../Helpers/CloseBtn/Close";
import { useContext, useEffect, useState } from "react";
import { filtrationcontext } from "../../../../../context/Filtercontext";
import Searchbar from "../../../../Helpers/Searchbar/Searchbar";
import trans from "../../../../../utils";
import AlertTable from "./AlertTable";
import { formatDateString } from "../../../../../JsHelpers/DateFormat";
import axios from "axios";
import { SpeedUnit } from "../../../../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";
import { Tag } from "antd";

const AlertPopup = ({ title, setAlertPopup }) => {
  const { limit, setLimit, setSearchQuery } = useContext(filtrationcontext);
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const [addresses, setAddresses] = useState([]);
  const inf = useSelector((state) => state.users.user);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });

  const handleSearch = (e) => {
    setQuery(e.target.value);
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    return () => setSearchQuery("");
  }, [setSearchQuery]);

  useEffect(() => {
    localStorage.setItem("page", currentPage);
  }, [currentPage]);

  const truncateItem = (text) => {
    const maxLength = 25;
    return text?.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const fetchGeoCodePosition = async (lat, lon, deviceUniqueId) => {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`
      );
      const newAddress = `${response.data.display_name}`;
      setAddresses((prevAddresses) => {
        const existingIndex = prevAddresses.findIndex(
          (item) => item.deviceUniqueId === deviceUniqueId
        );

        if (existingIndex !== -1) {
          const updatedAddresses = [...prevAddresses];
          updatedAddresses[existingIndex] = {
            deviceUniqueId,
            lat,
            lon,
            newAddress,
          };
          return updatedAddresses;
        } else {
          return [...prevAddresses, { deviceUniqueId, lat, lon, newAddress }];
        }
      });
    } catch (error) {
      console.error("Error fetching geocode position:", error);
    }
  };

  const getAddressForDevice = (deviceUniqueId) => {
    const addressObj = addresses.find(
      (item) => item.deviceUniqueId === deviceUniqueId
    );
    if (addressObj) {
      return (
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${addressObj.lat},${addressObj.lon}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover-undreline"
        >
          {addressObj.newAddress}
        </a>
      );
    }
    return null;
  };

  let columns = [];
  let type = "";

  if (title === "Speed Alerts") {
    columns = [
      {
        title: trans("Vehicle"),
        dataIndex: "deviceName",
        width: 150,
        sorter: true,
      },
      {
        title: trans("IMEI"),
        dataIndex: "deviceUniqueId",
        width: 150,
        sorter: true,
      },
      {
        title: trans("Address"),
        width: 250,
        render: (_, record) => {
          return (
            <span
              className="text-primary cursor"
              onClick={() =>
                fetchGeoCodePosition(
                  record.latitude,
                  record.longitude,
                  record.id
                )
              }
            >
              {getAddressForDevice(record.id) || trans("Get Address")}
            </span>
          );
        },
      },
      {
        title: trans("Speed"),
        dataIndex: "speed",
        width: 100,
        sorter: true,
        render: (value) => SpeedUnit(value, inf.attributes?.speedUnit || "kn"),
      },
      {
        title: trans("Speed Limit"),
        dataIndex: "speedLimit",
        width: 100,
        sorter: true,
        render: (value) => SpeedUnit(value, inf.attributes?.speedUnit || "kn"),
      },
      {
        title: trans("Alert Time"),
        dataIndex: "time",
        width: 180,
        sorter: true,
        render: (value) => (value ? formatDateString(value) : "- - - - -"),
      },
    ];
    type = "speedAlert";
  } else if (title === "Idle Alerts") {
    columns = [
      { title: "Vehicle", dataIndex: "vehicle", width: 150 },
      { title: "IMEI", dataIndex: "imei", width: 150 },
      { title: "Address", dataIndex: "address", width: 200 },
      { title: "Driver", dataIndex: "driver", width: 150 },
      { title: "Idle Time", dataIndex: "idleTime", width: 100 },
      { title: "Alert Time", dataIndex: "time", width: 180 },
    ];
    type = "idleAlert";
  } else if (title === "Power Cut") {
    columns = [
      { title: "Vehicle", dataIndex: "vehicle", width: 150 },
      { title: "IMEI", dataIndex: "imei", width: 150 },
      { title: "Address", dataIndex: "address", width: 200 },
      { title: "Driver", dataIndex: "driver", width: 150 },
      { title: "Alert Time", dataIndex: "time", width: 180 },
    ];
    type = "powercutAlert";
  } else if (title === "Geofences Alerts") {
    columns = [
      {
        title: trans("Vehicle"),
        dataIndex: "deviceName",
        width: 150,
        sorter: true,
      },
      {
        title: trans("IMEI"),
        dataIndex: "deviceUniqueId",
        width: 150,
        sorter: true,
      },
      {
        title: trans("Address"),
        width: 250,
        render: (_, record) => {
          return (
            <span
              className="text-primary cursor"
              onClick={() =>
                fetchGeoCodePosition(
                  record.latitude,
                  record.longitude,
                  record.id
                )
              }
            >
              {getAddressForDevice(record.id) || trans("Get Address")}
            </span>
          );
        },
      },
      {
        title: trans("Geofence"),
        dataIndex: "geofenceName",
        width: 150,
        sorter: true,
        render: (value) => (value ? value : "- - - - -"),
      },
      {
        title: trans("Geofence Type"),
        dataIndex: "type",
        width: 150,
        sorter: true,
      },
      {
        title: trans("Time"),
        dataIndex: "time",
        width: 200,
        sorter: true,
        render: (value) => (value ? formatDateString(value) : "- - - - -"),
      },
      {
        title: trans("Event"),
        dataIndex: "geofenceSpeed",
        width: 300,
        render: (_, record) =>
          record.geofenceSpeed ? (
            <>
              Speed Limit Exceeded: Allowed{" "}
              <Tag color="blue">
                {SpeedUnit(
                  record.geofenceSpeed.speedLimit,
                  inf.attributes?.speedUnit || "km/h"
                )}
              </Tag>
              <br />
              Actual{" "}
              <Tag color="red">
                {SpeedUnit(
                  record.geofenceSpeed.speed,
                  inf.attributes?.speedUnit || "km/h"
                )}
              </Tag>
            </>
          ) : (
            "- - - - -"
          ),
      },
    ];
    type = "geofencesAlert";
  } else if (title === "Other Alerts") {
    columns = [
      {
        title: trans("Vehicle"),
        dataIndex: "deviceName",
        sorter: true,
        width: 150,
      },
      {
        title: trans("IMEI"),
        dataIndex: "deviceUniqueId",
        sorter: true,
        width: 150,
      },
      {
        title: trans("Address"),
        width: 250,
        render: (_, record) => {
          return (
            <span
              className="text-primary cursor"
              onClick={() =>
                fetchGeoCodePosition(
                  record.latitude,
                  record.longitude,
                  record.id
                )
              }
            >
              {getAddressForDevice(record.id) || trans("Get Address")}
            </span>
          );
        },
      },
      {
        title: trans("Alert Type"),
        dataIndex: "type",
        sorter: true,
        width: 150,
      },
      {
        title: trans("Alert Time"),
        dataIndex: "time",
        sorter: true,
        width: 180,
      },
    ];
    type = "otherAlert";
  } else {
    columns = [
      { title: "Vehicle", dataIndex: "vehicle", width: 150 },
      { title: "IMEI", dataIndex: "imei", width: 150 },
      { title: "Address", dataIndex: "address", width: 200 },
      { title: "SOS Time", dataIndex: "sosTime", width: 150 },
      { title: "Alert Time", dataIndex: "time", width: 180 },
    ];
    type = "sosAlert";
  }

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setSort({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      setSort({
        by: "id",
        order: "desc",
      });
    }
  };

  return (
    <Popup show={!!title}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle headtitle={`${trans(title)}`} style="" nospace={true} />
        </Modal.Title>
        <Close
          style="close-32 close"
          close={() => setAlertPopup("")}
          img="Close"
        />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <Searchbar
          style="search search-dark input-group"
          path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
          placeholder={trans("Search")}
          value={query}
          onChange={handleSearch}
        />
        <div className="mt-3 table-parent">
          <AlertTable
            title={title}
            limit={limit}
            query={query}
            setLimit={setLimit}
            setQuery={setQuery}
            columns={columns}
            sort={sort}
            handleTableChange={handleTableChange}
          />
        </div>
      </Modal.Body>
    </Popup>
  );
};

export default AlertPopup;
